import { StoreProduct, CostHistoryEntry, PriceHistoryEntry } from 'dtos/catalog/product.dto';
import { PaginatedResponse, toPaginatedResponse } from 'dtos/common/api.dto';
import { apiClient } from 'services/api-client';

export class ProductService {
  static async list(orgId: string, storeId: string, search?: string, category?: string, page = 1, pageSize = 8): Promise<PaginatedResponse<StoreProduct>> {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (category) params.set('category', category);
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));
    const response = await apiClient.get<any>(`/orgs/${orgId}/stores/${storeId}/products?${params}`);
    return toPaginatedResponse({ ...response, data: response.data.map((row: any) => ({ ...row, product_id: row.id, product: { ...row, id: row.id, active: row.active } })) }, page, pageSize);
  }

  static async getCategories(orgId: string, storeId: string): Promise<string[]> {
    const products = await this.list(orgId, storeId, undefined, undefined, 1, 1000);
    return [...new Set(products.data.map(product => product.product?.category).filter(Boolean) as string[])].sort();
  }

  static async getDetail(orgId: string, storeId: string, productId: string): Promise<any> {
    const response = await apiClient.get<any>(`/orgs/${orgId}/stores/${storeId}/products/${productId}`);
    return response.data;
  }

  static async getCostHistory(orgId: string, storeId: string, productId: string): Promise<CostHistoryEntry[]> {
    const response = await apiClient.get<CostHistoryEntry[]>(`/orgs/${orgId}/stores/${storeId}/products/${productId}/cost`);
    return response.data;
  }

  static async getPriceHistory(orgId: string, storeId: string, productId: string): Promise<PriceHistoryEntry[]> {
    const response = await apiClient.get<PriceHistoryEntry[]>(`/orgs/${orgId}/stores/${storeId}/products/${productId}/price`);
    return response.data;
  }

  static async addManualCost(orgId: string, storeId: string, productId: string, input: { unit_cost: number; effective_date: string; reason: string; supplier_id?: string }): Promise<CostHistoryEntry> {
    const response = await apiClient.post<CostHistoryEntry>(`/orgs/${orgId}/stores/${storeId}/products/${productId}/costs`, input);
    return response.data;
  }

  static async upsertSupplier(orgId: string, storeId: string, productId: string, supplierId: string, input: { current_cost: number; supplier_sku?: string; preferred?: boolean }): Promise<void> {
    await apiClient.patch(`/orgs/${orgId}/stores/${storeId}/products/${productId}/suppliers/${supplierId}`, input);
  }

  static async removeSupplier(orgId: string, storeId: string, productId: string, supplierId: string): Promise<void> {
    await apiClient.delete(`/orgs/${orgId}/stores/${storeId}/products/${productId}/suppliers/${supplierId}`);
  }
}

